import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import MortgagePreapprovalMeeting from "@/pages/tools/MortgagePreapprovalMeeting";

export const Route = createFileRoute("/tools/mortgage-preapproval-meeting")({
  head: () => seoHead("/tools/mortgage-preapproval-meeting"),
  component: MortgagePreapprovalMeeting,
});
